/**
 * interact.js 1.10.26
 *
 * Copyright (c) 2012-present Taye Adeyemi <dev@taye.me>
 * Released under the MIT License.
 * https://raw.github.com/taye/interact.js/main/LICENSE
 */

import edgeTarget from './edgeTarget.js';
import elements from './elements.js';
import grid from './grid.js';

/* eslint-disable import/no-named-as-default, import/no-unresolved */

var allSnappers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  edgeTarget: edgeTarget,
  elements: elements,
  grid: grid
});
export { allSnappers as a };
//# sourceMappingURL=all-cc9e2779.js.map
